export const getColorFromTheme = (themeCssVariable: string) => {
  return window.getComputedStyle(document.body).getPropertyValue(themeCssVariable)
}
